import Rewards1 from "./../assets/rewards/1.webp";
import Rewards2 from "./../assets/rewards/2.webp";
import Rewards3 from "./../assets/rewards/3.webp";
import Rewards4 from "./../assets/rewards/4.webp";
import Rewards5 from "./../assets/rewards/5.webp";
import Rewards6 from "./../assets/rewards/6.webp";
import Rewards7 from "./../assets/rewards/7.webp";
import Rewards8 from "./../assets/rewards/8.webp";
import Rewards9 from "./../assets/rewards/9.webp";
import Rewards10 from "./../assets/rewards/10.webp";
const RewardsData = {
  rewards: [
    {
      id: 2001,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards1,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2002,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards2,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2003,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards3,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2004,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards4,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2005,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards5,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2006,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards6,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2007,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards7,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2008,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards8,
      writer: "",
      blogbanner: [],
    },
    {
      id: 2009,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards9,
      writer: "",
      blogbanner: [],
    },
    {
      id: 20010,
      title: "",
      desc: "",
      date: "",
      category: [""],
      images: Rewards10,
      writer: "",
      blogbanner: [],
    },
  ],
};

export default RewardsData;
